import React, { Component } from "react";
import {Container} from "react-bootstrap";
import {Jumbotron} from "./helpers/Jumbotron";
import Footer from "./Footer";

export default class fourOFour extends Component{

    render() {

        return<div className={"main-content"}>
            <Container>
                <Jumbotron style={{maxWidth:500}} className={"mx-auto mt-5 text-center"}>
                    <h1>404</h1>
                    <br/>
                    <p>The page you were looking for does not exist.</p>
                </Jumbotron>
                <div className={"mx-auto mt-5"}>
                </div>
                <Footer/>
            </Container>
        </div>
    }
}
